<template lang="pug">
v-container(fluid).pa-0
  menu-course-type-select.mb-2
  crud-scroll-details(
    ref="list"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
    :multiple="multiple"
  )
    template(#list-header="{ init, unSelect, resetSearch }")
      v-row.mb-2(no-gutters)
        v-col
          v-btn(
            block tile depressed
            :color="tab === 0 ? 'secondary' : ''"
            @click="tab = 0; init(); unSelect(); multiple = false;"
          ) Сформируйте
        v-col
          v-btn(
            block tile depressed
            :color="tab === 1 ? 'secondary' : ''"
            @click="tab = 1; init(); unSelect(); multiple = false;"
          ) Подпишите
        v-col
          v-btn(
            block tile depressed
            :color="tab === 2 ? 'secondary' : ''"
            @click="tab = 2; init(); unSelect(); multiple = false;"
          ) Сформированные
    template(#list-header-bottom="{ indeterminate, selectAll, unSelectAll, isAllSelected }")
      .d-flex.px-3.align-end.py-1(v-if="tab !== 2")
        v-checkbox.pt-0.mt-0.ml-1(
          v-if="multiple"
          :input-value="isAllSelected"
          :indeterminate="indeterminate"
          :label="isAllSelected ? 'Отмена' : 'Выбрать все'"
          hide-details
          @change="$event ? selectAll() : unSelectAll()"
        )
        v-switch.ml-auto(
          v-model="multiple"
          color="secondary"
          rounded
          text
          inset
          :label="`Режим ${ tab ? 'подписания' : 'формирования'}`"
          outlined
          hide-details
        ).pt-0.mt-1
      v-chip-group.px-2(
        v-else
        v-model="selectedTags"
        active-class="secondary"
        column mandatory
      )
        v-chip(small :value="[4,5]") Все
        v-chip(small :value="5") Выданные
        v-chip(small :value="4") Не выданные

    template(#list-item="{ item, active }")
      v-list-item-icon(v-if="!multiple").mr-4
        v-icon( size="28"
        ) mdi-account
      v-list-item-content

        strong {{ item.user.full_name || item.user.name }}
        .text-caption.align-center.d-flex(v-if="item.course")
          v-icon(left small) mdi-book-open-page-variant-outline
          span {{ item.course.short_title}}
        .caption(v-if="item.serial")
          v-icon(left small) mdi-certificate-outline
          span {{  item.serial }} {{  item.number }}
      v-list-item-action(v-if="item.downloaded_at"): v-icon(
        color="success"
      ) mdi-account-arrow-down

</template>

<script>
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import CertificateActions from '../components/CertificateActions.vue';
import CertificateDetail from '../components/CertificateDetail.vue';
import MenuCourseTypeSelect from '../components/MenuCourseTypeSelect.vue';

export default {
  components: {
    CrudScrollDetails,
    MenuCourseTypeSelect,
  },
  data() {
    return {
      tab: 0,
      selectedTags: [4, 5],
      isAllSelected: false,
      multiple: false,
    };
  },
  watch: {
    multiple() {
      this.isAllSelected = false;
    },
    selectedTags() {
      this.$refs.list.refreshList();
    },
  },
  computed: {
    detailsComponent() {
      const component = this.multiple ? CertificateActions : CertificateDetail;
      return {
        component,
        component_attrs: { tab: this.tab },
        component_listeners: {
          unSelect: () => {
            this.$refs.list.unSelect();
            this.$refs.list.refreshList();
            this.multiple = false;
          },
        },
      };
    },
    // query() {
    //   const resulst = {};
    //   return resulst;
    // },
  },

  methods: {
    signDocument() {},
    selectById(id) {
      this.$refs.list.selectById(id);
    },
    adapter(params) {
      const byTab = {
        0: {
          'search[without_diploma]': 1,
          'search[status]': 4,
          'search[course_type]': 2,
        },
        1: { 'search[status]': 3 },
        2: { 'search[status]': this.selectedTags },
      };
      const method = this.tab ? 'getDiplomas' : 'getPriorRecordUsers';
      return this.$api.diploma[method]({
        expand: 'user,prior_record,group,organization_user,course',
        ...byTab[this.tab],
        ...params,
      });
    },
  },
};
</script>
